import ChatIcon from '@/components/ChatIcon'
import './SectionNameWithCommentCount.style.less'
import ChatButton from '@/components/ChatButton/ChatButton'

interface Props {
  name: string
  commentCount?: number
  onClick?: () => void
  newUpdate?: boolean
}

function SectionNameWithCommentCount(props: Props) {
  return (
    <div
      className="section-name-with-comment-count-container"
      onClick={props.onClick}
    >
      <p className="section-name">{props.name}</p>

      {props.commentCount > 0 && (
        <ChatButton
          redPoint={!!props.newUpdate}
          onClick={props.onClick}
          chatCount={props.commentCount}
        />
      )}
    </div>
  )
}

export default SectionNameWithCommentCount
